import React from 'react';

interface GooglePlayStoreButtonProps {
  onClick: () => void;
}

export default function GooglePlayStoreButton({ onClick }: GooglePlayStoreButtonProps) {
  return (
    <button
      onClick={onClick}
      className='flex w-fit items-center gap-2 rounded-3 border border-solid border-black bg-white px-2 py-1'
    >
      <svg width='21' height='24' viewBox='0 0 21 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M9.80482 11.4617L0.0895996 22.0059C0.0905121 22.0078 0.090512 22.0106 0.0914244 22.0125C0.389807 23.1574 1.41179 24 2.62539 24C3.11083 24 3.56616 23.8656 3.95671 23.6305L3.98773 23.6118L14.9229 17.1593L9.80482 11.4617Z'
          fill='#EA4335'
        />
        <path
          d='M19.6331 9.66619L19.624 9.65966L14.9028 6.86123L9.58391 11.7013L14.9219 17.1582L19.6176 14.3878C20.4406 13.9324 21 13.045 21 12.0223C21 11.0052 20.4489 10.1225 19.6331 9.66619Z'
          fill='#FBBC04'
        />
        <path
          d='M0.0894234 1.99331C0.0310244 2.21353 0 2.44494 0 2.68382V21.3163C0 21.5552 0.0310245 21.7866 0.0903359 22.0059L10.1386 11.7313L0.0894234 1.99331Z'
          fill='#4285F4'
        />
        <path
          d='M9.87657 11.9999L14.9044 6.85935L3.98192 0.383507C3.58499 0.139962 3.12145 -4.76837e-06 2.62597 -4.76837e-06C1.41237 -4.76837e-06 0.388558 0.844468 0.0901759 1.99034C0.0901759 1.99127 0.0892639 1.9922 0.0892639 1.99314L9.87657 11.9999Z'
          fill='#34A853'
        />
      </svg>
      <div className='text-left text-black'>
        <p className='line-clamp-1 text-xs'>GET IT ON</p>
        <p className='text-sm font-semibold'>Google Play</p>
      </div>
    </button>
  );
}
